import clsx from "clsx";
import { CompareRow } from "./@types";
import ScalarRow from "./ScalarRow";
import SetRow from "./SetRow";
import styles from "./compare-samples.module.scss";

interface CompareTableProps {
  rows: CompareRow[];
}

const CompareTable = ({ rows }: CompareTableProps): JSX.Element => {
  if (!rows.length) {
    return (
      <div className={clsx(styles.placeholder, "text-center")}>
        These samples match on every compared field.
      </div>
    );
  }

  const blocks: JSX.Element[] = [];
  let currentGroup: string | undefined;

  rows.forEach(row => {
    if (row.group !== currentGroup) {
      currentGroup = row.group;
      blocks.push(
        <div className={styles.group} key={`group-${row.group}`}>
          {row.group}
        </div>
      );
    }

    const key = `${row.group}-${row.label}`;
    blocks.push(
      row.kind === "set" ? (
        <SetRow row={row} key={key} />
      ) : (
        <ScalarRow row={row} key={key} />
      )
    );
  });

  return <div className={styles.table}>{blocks}</div>;
};

export default CompareTable;
